import { createContext } from "react"

import { AudioVideoFacade } from "amazon-chime-sdk-js"

import { Subscription } from "@rails/actioncable"

import { AttendeeInfo } from "./hooks/useAttendeeInfo"
import type { SessionConfig } from "./hooks/useCloudroomSessionConfig"
import { RosterEntry } from "./hooks/useRoster"

import { ErrorType } from "./Cloudroom"

export type CloudroomContextValue = {
  // provided by every CloudroomContext.Provider (CloudroomProvider and QualityControlLayout)
  session: any
  ghost: boolean
  audioVideo: AudioVideoFacade
  audioSetupInProgress: boolean
  videoSetupInProgress: boolean
  roster: Record<string, RosterEntry>
  localUser: any

  // only provided by CloudroomProvider
  channel?: Subscription
  sessionConfig?: SessionConfig
  error?: ErrorType | null
  clearError?: () => void

  muteLocalAudio?: () => void
  unmuteLocalAudio?: () => Promise<void>
  muteLocalVideo?: () => void
  unmuteLocalVideo?: () => void
  localControlsLocked?: boolean

  allAudioMuted?: boolean
  toggleAllAudio?: () => void
  allVideoMuted?: boolean
  toggleAllVideo?: () => void
  allControlsLocked?: boolean
  toggleAllControlsLocked?: () => void
  controlsLockedUserIds?: string[]

  surveyOpen?: boolean
  setSurveyOpen?: (open: boolean) => void

  activeLanguageCode?: string | null
  setActiveLanguageCode?: (languageCode: string | null) => void
  playbackRate?: number
  setPlaybackRate?: (rate: number) => void

  getInfoForExternalUserId?: (
    externalUserId: string | undefined
  ) => AttendeeInfo
}

const CloudroomContext = createContext<CloudroomContextValue>(
  {} as CloudroomContextValue
)

export default CloudroomContext
